import * as angular from "angular";
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SitesRequestsService} from "./sites-requests.service";

export class SitesService {

  constructor(private bringozLoaderService: BringozLoaderService, private $q: IQService,
              private sitesRequestsService: SitesRequestsService) {
  }

  getSitePolicy(siteId, branchIds?: string[]) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.sitesRequestsService.getSitePolicy(siteId, branchIds)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.sites')
  .service('sitesService', SitesService);
